import { isApolloErrorWithCode } from 'lib/helpers/isApolloErrorWithCode/isApolloErrorWithCode'
import { EntityNotFoundError } from '../../EntityNotFoundError'

export const isExpectedNotFound = (error: unknown): boolean =>
  isApolloErrorWithCode(error, { code: 'not_found' }) || error instanceof EntityNotFoundError
